import { gql } from "@apollo/client";

import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

import { identifierFragment } from "./IdentifierFragment";

export const elementFragment = gql`
  fragment ElementFragment on Element {
    id
    name
    typeCode
    schemaElement {
      name
      code
    }
    configurableType {
      code
      name
    }
    properties {
      ...PropertyValueFragment
    }
    elements {
      id
      name
      typeCode
      schemaElement {
        name
        code
      }
      configurableType {
        code
        name
      }
      properties {
        ...PropertyValueFragment
      }
    }
    identifiers {
      ...IdentifierFragment
    }
  }

  ${propertyValueFragment}
  ${identifierFragment}
`;
